import {IFilterGroup} from 'plugins/modules/filter/types';

export const GROUPS_VINO: IFilterGroup = {
    ALCOHOL: {
        groupWithCollapse: true,
        title: 'Содержание алкоголя',
    },
    COLOR: {
        groupWithCollapse: true,
        title: 'Цвет',
    },
    FEATURES: {
        groupWithCollapse: true,
        title: 'Особенности',
    },
    GASTRONOMY: {
        groupWithCollapse: true,
        title: 'Гастрономия и вкус',
        withSearch: true,
    },
    GEO: {
        groupWithCollapse: true,
        title: 'География',
        withSearch: true,
    },
    GRAPE: {
        groupSearchPlaceholder: 'Сорт винограда',
        groupWithCollapse: true,
        title: 'Сорт винограда',
        withSearch: true,
    },
    PRICE: {
        groupWithCollapse: true,
        title: 'Цена',
    },
    RATING: {
        groupWithCollapse: true,
        title: 'Рейтинги и критики',
    },
};
